import ComicCard from '@/components/base/ComicCard';
import { comics, categories } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = comics.filter((c) => c.featured);

  return (
    <section className="px-4 md:px-6 max-w-[1200px] mx-auto py-12" aria-label="精选推荐漫画" data-product-shop="">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">精选推荐</h2>
          <p className="text-sm text-foreground-500 mt-2">编辑精心挑选的高分漫画，不容错过</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
        {featured.map((comic) => {
          const catInfo = categories.find((c) => c.slug === comic.category);
          return (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              cover={comic.cover}
              category={comic.category}
              categoryName={catInfo?.name || comic.category}
              status={comic.status}
              rating={comic.rating}
              views={comic.views}
              chapters={comic.chapters}
            />
          );
        })}
      </div>
    </section>
  );
}